let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lrwAv")).then(() => parcelRequire('hLw8T'));